import React, { createContext, useContext, useEffect, useRef, useState } from 'react';
import { useUnityContext } from '../../container/unityContainer';
import { useUnityCameraFields } from './components/camera/useUnityCameraFields';
import { useUnityHDRI } from './components/lights/useUnityHDRI';
import { useUnityLight } from './components/lights/useUnityLight';
import { useUnityShortcuts } from './CuratorHeader/useUnityShortcuts';
import { useUnityMetadata } from './MetadataSection/useUnityMetadata';
import { useUnityColors } from './stylesSection/useUnityColors';
import { useUnityMaterial } from './stylesSection/useUnityMaterial';
import { useUnityRedux } from './stylesSection/useUnityRedux';
import { undoRedo } from './UndoRedo/UndoRedo';

export const UndoRedoContext = createContext({});

export const UndoRedoContextProvider = (props) => {
  const [loaded, setLoaded] = useState(false)
  const unityContext = useUnityContext();
  const unityLight = useUnityLight();
  const unityHDRI = useUnityHDRI();
  const undoRedoRef = useRef(undoRedo);
  const unityRedux = useUnityRedux();
  const unityMaterial = useUnityMaterial();
  const unityColor = useUnityColors();
  const unityCameraFields = useUnityCameraFields();
  const unityShortcuts = useUnityShortcuts();
  const unityMetadata = useUnityMetadata()

  useEffect(() => {
    undoRedoRef.current.setUnityContext(unityContext);
    undoRedoRef.current.setUnityLight(unityLight);
    undoRedoRef.current.setUnityRedux(unityRedux);
    undoRedoRef.current.setUnityColor(unityColor);
    undoRedoRef.current.setUnityCameraFields(unityCameraFields);
    undoRedoRef.current.setUnityMaterial(unityMaterial);
    undoRedoRef.current.setUnityHDRI(unityHDRI);
    undoRedoRef.current.setUnityShortcuts(unityShortcuts)
    undoRedoRef.current.setUnityMetadata(unityMetadata)
    undoRedoRef.current.init();
    setLoaded(true)
  }, [])  

  return (
    <UndoRedoContext.Provider
      value={undoRedoRef.current}
    >
      {loaded && props.children}
    </UndoRedoContext.Provider>
  );
};

export const useUndoRedo = () => useContext(UndoRedoContext);

